import styled, { css } from 'styled-components/macro';
import { Link as RouterLink } from 'react-router-dom';
import * as colors from '../colorConstants';
import * as breakpoints from '../mediaQueries';

export const buttonWithIcon = css`
  user-select: none;
  outline: none !important;
  appearance: none;
  text-decoration: none !important;
  border: none;
  background-color: transparent;
  width: 100%;
  ${(props) => props.$topborder && `border-top: 1px solid ${colors.lightGray3}`};
  ${(props) => props.$botborder && `border-bottom: 1px solid ${colors.lightGray3}`};
  ${(props) =>
    props.$withborders &&
    `
    border-top: 1px solid ${colors.lightGray3};
    border-bottom: 1px solid ${colors.lightGray3};
  `};
  pointer-events: ${(props) => props.disableclicks && 'none'};

  background-image: url(${(props) => props.src});
  ${(props) => props.$islogo && `filter: var(--logo-filter);`}
  padding-top: 36px;
  padding-bottom: 8px;
  background-size: ${(props) => (props.$islogo ? '17px' : '19px')};
  background-position: center 11px;
  background-repeat: no-repeat;
  transition: 0.2s linear;
  text-transform: capitalize;
  color: ${colors.lightWhite} !important;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;
  :hover {
    ${(props) =>
      props.hoversrc &&
      `
      background-image: ${props.showspinner ? 'none' : `url(${props.hoversrc})`};
      background-color: ${colors.darkGray5};
    `};
  }

  @media (min-height: ${breakpoints.mediumHeight}) {
    background-size: ${(props) => (props.$islogo ? '19px' : '23px')};
    background-position: center 11px;
    padding-top: 36px;
    padding-bottom: 8px;
    font-size: 10px;
    line-height: 12px;
  }
  @media (min-height: ${breakpoints.normalHeight}) {
    font-size: 11px;
    line-height: 13px;
    padding-top: 36px;
    padding-bottom: 8px;
  }

  ${(props) => props.showspinner && `background-image: none`};
`;

export const Link = styled(RouterLink)`
  ${buttonWithIcon}
`;

export const Button = styled.button`
  ${buttonWithIcon};
`;

export const ExternalLink = styled.a`
  ${buttonWithIcon}
`;

export const Icon = styled.div`
  background-image: url(${(props) => props.src});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 21px;
  height: 21px;
  transition: 0.2s linear;

  ${(props) =>
    props.hoversrc &&
    `
    :hover {
      background-image: url(${props.hoversrc});
    }
  `};

  @media (min-height: ${breakpoints.mediumHeight}) {
    width: 23px;
    height: 23px;
  }

  @media (min-height: ${breakpoints.normalHeight}) {
    width: 25px;
    height: 25px;
  }
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  width: 40px;
  height: 21px;
  top: 10px;

  @media (min-height: ${breakpoints.mediumHeight}) {
    height: 23px;
  }

  @media (min-height: ${breakpoints.normalHeight}) {
    height: 25px;
  }
`;

export const ArrowIcon = styled(Icon)`
  width: 7px !important;
  height: 6px !important;
  background-image: url('/images/new-designs/arrow-down-thin.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transform: ${(props) => (!props.rotate ? `rotateX(-180deg)` : `rotateX(0)`)};
  transition: 0.3s linear;
  margin-top: 7px;
`;
